export default __webpack_public_path__ + "static/media/19.e3b4f3b1.png";